<template>
  <div class="m-soon">
    <i class="material-icons">construction</i>
    <p>{{ $t("mobile.comingSoon") }}</p>
  </div>
</template>

<script>
export default {
  name: "MobileComingSoon",
};
</script>

<style lang="scss" scoped>
.m-soon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 25vh 32px 0;
  text-align: center;
  color: #9e9e9e;

  i {
    font-size: 48px;
  }

  p {
    font-size: 15px;
    margin: 0;
  }
}
</style>
